/**
 * @generated SignedSource<<e81272becab671f3a41471b4a8484828>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type waitlistScreen_ReferralApplyMutation$variables = {
  code: string;
  token?: string | null | undefined;
};
export type waitlistScreen_ReferralApplyMutation$data = {
  readonly leadReferralApply: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly lead: {
      readonly position: number | null | undefined;
      readonly waitDays: number | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type waitlistScreen_ReferralApplyMutation = {
  response: waitlistScreen_ReferralApplyMutation$data;
  variables: waitlistScreen_ReferralApplyMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "code"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "token"
},
v2 = [
  {
    "kind": "Variable",
    "name": "code",
    "variableName": "code"
  },
  {
    "kind": "Variable",
    "name": "token",
    "variableName": "token"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Lead",
  "kind": "LinkedField",
  "name": "lead",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "position",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "waitDays",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "waitlistScreen_ReferralApplyMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "LeadReferralApplyMutationPayload",
        "kind": "LinkedField",
        "name": "leadReferralApply",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "waitlistScreen_ReferralApplyMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "LeadReferralApplyMutationPayload",
        "kind": "LinkedField",
        "name": "leadReferralApply",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2ebc63b3ec8bb22d40ee31864cbce65d",
    "id": null,
    "metadata": {},
    "name": "waitlistScreen_ReferralApplyMutation",
    "operationKind": "mutation",
    "text": "mutation waitlistScreen_ReferralApplyMutation(\n  $token: String\n  $code: String!\n) {\n  leadReferralApply(token: $token, code: $code) {\n    lead {\n      position\n      waitDays\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "26dd40e173b8a6e12c75dce136a12e2c";

export default node;
